module.exports = __webpack_public_path__ + "static/kettle-creek-cf172ad975100cfcb0ee4bb201e62bb8.jpg";